import { NgModule }                 from '@angular/core';
import { RouterModule, Routes }     from '@angular/router';
import { AppComponent }             from './app.component';
import { LoginComponent }           from './login/login.component';
import { UserComponent }            from './member-kanri/user.component';
import { DriverComponent }          from './member-kanri/driver.component';
import { CompanyComponent }         from './member-kanri/company.component';
import { CarComponent }             from './member-kanri/car.component';
import { MobileMainComponent }      from './mobile/mobile-main.component';
import { TransReportComponent }     from './mobile/trans-report.component';
import { SearchCargoComponent }     from './mobile/search-cargo.component';
import { AuthGuard }                from './login/auth-guard.service';
import { ClientCargoComponent }     from './cargo/client-cargo.component';
import { TransportCargoComponent }  from './cargo/transport-cargo.component';
import { GooglemapComponent }       from './common/googlemap.component';
import { ScheduleMainComponent }    from './schedule/schedule-main.component';
import { MemberRegistComponent }    from './member-kanri/member-regist.component';
import { NoticeComponent }          from './notice/notice.component';
import { MobileNoticeComponent }    from './mobile/notice.component';
import { StatisticComponent }       from './statistic/statistic.component';
import { CaseManagementComponent }  from './case/case-management.component';
import { NoticeShowComponent }      from './notice/notice-show.component';
import { StateRegistComponent }     from './statement/state-regist.component';
import { StateTotalComponent }      from './statement/state-total.component';
import { StateTotalComponentNew }   from './statement/state-total-new.component';
import { StateTotalComponentTest }  from './statement/state-total-test.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  // {
  //   path: 'transport-regist',
  //   component: MemberRegistComponent
  // },
  // {
  //   path: 'client-regist',
  //   component: MemberRegistComponent
  // },
  {
    path: 'notice-show',
    canActivate: [ AuthGuard ],
    component: NoticeShowComponent
  },
  // {
  //   path: 'client-update',
  //   canActivate: [ AuthGuard ],
  //   component: MemberRegistComponent
  // },
  // {
  //   path: 'partner-update',
  //   canActivate: [ AuthGuard ],
  //   component: MemberRegistComponent
  // },
  {
    path: 'cargo',
    canActivate: [ AuthGuard ],
    children: [
      // Ryobi
      // {
      //   path: 'client',
      //   canActivate: [ AuthGuard ],
      //   component: ClientCargoComponent
      // },
      // {
      //   path: 'transport',
      //   canActivate: [ AuthGuard ],
      //   component: TransportCargoComponent
      // },
      // End
      {
        path: 'case',
        canActivate: [ AuthGuard ],
        component: CaseManagementComponent,
        data: {
          role: 'ROLE_MANAGER'
        }
      }
    ]
  },
  {
    path: 'member',
    canActivate: [ AuthGuard ],
    children: [
      {
        path: 'user',
        canActivate: [ AuthGuard ],
        component: UserComponent,
        data: {
          role: 'ROLE_MANAGER'
        }
      },
      {
        path: 'leave-user',
        canActivate: [ AuthGuard ],
        component: UserComponent,
        data: {
          role: 'ROLE_MANAGER'
        }
      },
      {
        path: 'company',
        canActivate: [ AuthGuard ],
        component: CompanyComponent,
        data: {
          role: 'ROLE_MANAGER'
        }
      },
      {
        path: 'leave-company',
        canActivate: [ AuthGuard ],
        component: CompanyComponent,
        data: {
          role: 'ROLE_MANAGER'
        }
      },
      {
        path: 'leave-client',
        canActivate: [ AuthGuard ],
        component: CompanyComponent,
        data: {
          role: 'ROLE_MANAGER'
        }
      },
      {
        path: 'client',
        canActivate: [ AuthGuard ],
        component: CompanyComponent,
        data: {
          role: 'ROLE_MANAGER'
        }
      },
      {
        path: 'partner',
        canActivate: [ AuthGuard ],
        component: CompanyComponent,
        data: {
          role: 'ROLE_MANAGER'
        }
      },
      {
        path: 'leave-partner',
        canActivate: [ AuthGuard ],
        component: CompanyComponent,
        data: {
          role: 'ROLE_MANAGER'
        }
      },
      {
        path: 'car',
        canActivate: [ AuthGuard ],
        component: CarComponent,
        data: {
          role: 'ROLE_MANAGER|ROLE_NORMAL'
        }
      },
      {
        path: 'leave-car',
        canActivate: [ AuthGuard ],
        component: CarComponent,
        data: {
          role: 'ROLE_MANAGER'
        }
      },
      {
        path: 'driver',
        canActivate: [ AuthGuard ],
        component: DriverComponent,
        data: {
          role: 'ROLE_MANAGER'
        }
      },
      {
        path: 'leave-driver',
        canActivate: [ AuthGuard ],
        component: DriverComponent,
        data: {
          role: 'ROLE_MANAGER'
        }
      }
    ]
  },
  {
    path: 'statement',
    canActivate: [ AuthGuard ],
    children: [
      {
        path: 'state-regist',
        canActivate: [AuthGuard ],
        component: StateRegistComponent
      },
      {
        path: 'state-total',
        canActivate: [AuthGuard ],
        component: StateTotalComponent
      },
      {
        path: 'state-total-new',
        canActivate: [AuthGuard ],
        component: StateTotalComponentNew
      },
      {
        path: 'state-total-test',
        canActivate: [AuthGuard ],
        component: StateTotalComponentTest
      }
    ]
  },
  // {
  //   path: 'map',
  //   canActivate: [ AuthGuard ],
  //   component: GooglemapComponent
  // },
  // {
  //   path: 'schedule',
  //   canActivate: [ AuthGuard ],
  //   component: ScheduleMainComponent
  // },
  // {
  //   path: 'statistic',
  //   canActivate: [ AuthGuard ],
  //   component: StatisticComponent
  // },
  {
    path: 'notice',
    canActivate: [ AuthGuard ],
    component: NoticeComponent
  },
  // {
  //   path: 'mobile',
  //   canActivate: [ AuthGuard ],
  //   children: [
  //     {
  //       path: 'main',
  //       canActivate: [ AuthGuard ],
  //       component: MobileMainComponent
  //     },
  //     {
  //       path: 'search',
  //       canActivate: [ AuthGuard ],
  //       component: SearchCargoComponent
  //     },
  //     {
  //       path: 'report',
  //       canActivate: [ AuthGuard ],
  //       component: TransReportComponent
  //     },
  //     {
  //       path: 'history',
  //       canActivate: [ AuthGuard ],
  //       component: TransReportComponent
  //     },
  //     {
  //       path: 'notice',
  //       canActivate: [ AuthGuard ],
  //       component: MobileNoticeComponent
  //     }
  //   ]
  // }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {useHash: true}) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts